<n-slide-window
    [visible]="show"
    width="7rem"
    [showMask]="true">
    <n-header>
        <h1>{{i18nLabel.failedDetail}}</h1>
    </n-header>
    <div  *ngIf="!error.useNewTemplate; else newDetailTemplate">
        <div>
            <span>
                <svg class="icon icon-size-48">
                    <use xlink:href="#icon-popup-error-48"></use>
                </svg>
            </span>
            <span class="error-title">{{error.name}}</span>
        </div>
        <div class="block">
            <div class="block-title">{{i18nLabel.possibleCause}}</div>
            <ul>
                <li class="block-content">{{error.description}}</li>
            </ul>
        </div>

        <div class="block">
            <div class="block-title">{{i18nLabel.suggestion}}</div>
            <ul>
                <li class="block-content">{{error.suggestion}}</li>
            </ul>
        </div>
    </div>
    
    <n-footer>
        <div class="slide-error-botton-group">
            <button pButton
                id="tasks_error_detail_close_button"
                type="button"
                (click)="onClose()"
                [label]="i18nLabel.closeBtn">
            </button>
        </div>
    </n-footer>

    <ng-template #newDetailTemplate>
        <div class="mb-10">
            <span>
                <svg class="icon">
                    <use xlink:href="#icon-status-failed"></use>
                </svg>
            </span>
            <span class="ml-10">{{error.name}}</span>
        </div>
        <n-collapse class="task-error-detail" >
            <n-collapse-panel    
                *ngFor="let item of error.description"
                [header]="item.check_item"
                [key]="item.check_item + item.node">
                    <n-lv>
                        <n-lv-item *ngIf="item.node" [label]="i18nLabel.nodeLabel">{{item.node}}</n-lv-item>
                        <n-lv-item *ngIf="item.suggestion" [label]="i18nLabel.descriptionLabel">
                            <div [innerHTML]="item.suggestion.replace(brReg, '\<br\/>')"></div>
                        </n-lv-item>
                        <n-lv-item *ngIf="item.method" [label]="i18nLabel.rescoverySuggestion">
                            <div [innerHTML]="item.method.replace(brReg, '\<br\/>')"></div>
                        </n-lv-item>
                    </n-lv>
            </n-collapse-panel>
        </n-collapse>
    </ng-template>
</n-slide-window>
